var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('app-loader'):_c('application')}
var staticRenderFns = []

export { render, staticRenderFns }